module.exports = __webpack_public_path__ + "img/transparent-white.260200a7.png";